angular.module('eStories.player', [

    'eStories.player.model',
    'eStories.account.model',
    'eStories.library.model'

])

    .controller('PlayerCtrl', [
        '$rootScope',
        'PlayerModel',
        'AccountModel',
        'LibraryModel',
        '$scope',
        '$timeout',
        'LL',
        function ($rootScope,
                  PlayerModel,
                  AccountModel,
                  LibraryModel,
                  $scope,
                  $timeout,
                  LL) {

            var playerCtrl = this;

            $rootScope.playerModel = PlayerModel;

            $scope.$on('playAudiobook', function (e, libraryAudiobook) {
                PlayerModel.play(libraryAudiobook);
            });

            $scope.$on('playSample', function (e, audiobook) {
                LL.tagEvent('Play Sample', {'Book ID': audiobook.id});
                PlayerModel.play(audiobook, true);
            });

            $scope.$on('pauseSample', function (e, audiobook, isSample) {
                PlayerModel.pausePlaying(audiobook, true);
            });


            playerCtrl.switchControlMap = {
                next: {
                    timer: null,
                    showControl: null
                },

                previous: {
                    timer: null,
                    showControl: null
                }
            };

            playerCtrl.getSwitchControlObj = function (isNext) {
                var objName = isNext ? "next" : "previous";
                return playerCtrl.switchControlMap[objName];
            };

            playerCtrl.handleClearSwitchControlTimeout = function (isNext) {
                var obj = playerCtrl.getSwitchControlObj(isNext);
                if (obj.timer != null) {
                    clearTimeout(obj.timer);
                    obj.timer = null;
                }
                obj.showControl = false;
            };

            playerCtrl.handleSwitchControlMouseOver = function (isNext) {
                var obj = playerCtrl.getSwitchControlObj(isNext);
                if (playerCtrl.showSwitchControl(isNext)) {
                    return;
                }
                playerCtrl.handleClearSwitchControlTimeout(isNext);
                obj.timer = setTimeout(function () {
                    obj.showControl = true;
                    safeDigest($scope);
                }, 1500);
            };

            playerCtrl.showSwitchControl = function (isNext) {
                var obj = playerCtrl.getSwitchControlObj(isNext);
                return obj.showControl == true;
            };


            //Player Controllers
            playerCtrl.setVolumeOnSlider = function () {
                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender');
                });
            };

            playerCtrl.setInitialVolume = function () {
                if (playerCtrl.isMP3) {
                    playerCtrl.mp3Player.volume = 0.5;
                } else {
                    playerCtrl.findawayPlayer.trigger('set-volume', 50);
                }
            };

            playerCtrl.bookmarkNote = null;

            playerCtrl.openBookmarkOverlay = function (bookmarkObj) {
                playerCtrl.showPlayerAddBookmarkOverlay = true;
                if (bookmarkObj) {
                    playerCtrl.showBookmarkContent = true;
                    playerCtrl.bookmark = bookmarkObj;
                    playerCtrl.bookmarkNote = bookmarkObj.note;
                    playerCtrl.editBookmarkMode = true;
                } else {
                    playerCtrl.editBookmarkMode = false;
                    playerCtrl.bookmark = {
                        position: PlayerModel.currentPlayingLibraryAudiobook.progress.position,
                        chapter: PlayerModel.currentPlayingLibraryAudiobook.progress.chapter
                    }
                }
            };

            playerCtrl.updateBookmark = async function () {
                if (!playerCtrl.bookmark) {
                    return;
                }
                var updateBookmarkObj = {
                    id: playerCtrl.bookmark.id,
                    note: playerCtrl.bookmarkNote
                };
                const response = await LibraryModel.updateBookmark(updateBookmarkObj, PlayerModel.currentPlayingLibraryAudiobook);
                if (response != null && response.responseStatus == 'SUCCESS') {
                    playerCtrl.discardBookmark();
                    playerCtrl.updateBookmarkList(response.bookmark);
                }
            };

            playerCtrl.saveBookmark = async function () {
                var bookmark = playerCtrl.bookmark;
                if (!bookmark) {
                    return;
                }
                bookmark.note = playerCtrl.bookmarkNote;
                const response = await LibraryModel.saveBookmark(bookmark.position, bookmark.note, bookmark.chapter.id,
                    PlayerModel.currentPlayingLibraryAudiobook);

                if (response != null && response.responseStatus == 'SUCCESS') {
                    playerCtrl.discardBookmark();
                    PlayerModel.currentPlayingLibraryAudiobook.bookmarkList.push(response.bookmark);
                }
            };

            playerCtrl.updateBookmarkList = function (bookmark) {
                var bookmarkList = PlayerModel.currentPlayingLibraryAudiobook.bookmarkList;
                for (var i = 0; i < bookmarkList.length; i++) {
                    if (bookmarkList[i].id == bookmark.id) {
                        bookmarkList[i] = bookmark;
                    }
                }
            };

            playerCtrl.discardBookmark = function () {
                playerCtrl.bookmarkNote = null;
                playerCtrl.bookmark = {};
                playerCtrl.showBookmarkContent = false;
                playerCtrl.showPlayerAddBookmarkOverlay = false;
            };

            playerCtrl.getBookmarkPositionOnSlider = function (bookmarkObj) {
                var positionPercentage = (bookmarkObj.position / PlayerModel.currentPlayingLibraryAudiobook.progress.chapter.duration) * 100;
                return {
                    left: positionPercentage + '%'
                }
            };

            playerCtrl.getShortTime = function (position) {
                return LibraryModel.getShortTime(position);
            };

            playerCtrl.getBookmarkCountByChapter = function () {
                if (PlayerModel.currentPlayingLibraryAudiobook == null || playerCtrl.isMP3) {
                    return;
                }
                var currentPlayingChapter = PlayerModel.currentPlayingLibraryAudiobook.progress.chapter;
                var bookmarkList = PlayerModel.currentPlayingLibraryAudiobook.bookmarkList;
                var bookmarkCount = 0;
                for (var i = 0; i < bookmarkList.length; i++) {
                    if (currentPlayingChapter.id == bookmarkList[i].chapter.id) {
                        bookmarkCount++
                    }
                }
                return bookmarkCount;
            };

            playerCtrl.getTotalBookmarkCount = function () {
                return PlayerModel.getTotalBookmarkCount();
            };

            playerCtrl.openBookmarksModal = function () {
                LibraryModel.openBookmarksModal(PlayerModel.currentPlayingLibraryAudiobook);
            };
        }
    ])

    .controller('PlayerAlertCtrl', [
        '$uibModalInstance',
        'PlayerModel',
        '$filter',
        function ($uibModalInstance,
                  PlayerModel,
                  $filter) {

            var playerAlertCtrl = this;
            playerAlertCtrl.closeModal = function () {
                $uibModalInstance.close();
            };

            playerAlertCtrl.getAudiobookCoverBg = function () {
                var backgroundUrl = PlayerModel.audiobookPendingToPlay.audiobook.coverUrl;
                var url = $filter('imageByWidth')(backgroundUrl, 500);
                return {
                    background: 'url(' + url + ') center center no-repeat'
                }
            };
        }]);